/* eslint-disable no-param-reassign */

import Vue from 'vue';
import { isVNode } from '@uikit/ui-kit/src/utils/vdom';
import { PopupManager } from '@uikit/ui-kit/src/utils/popup';
import Main from './main.vue';

const NotificationExConstructor = Vue.extend(Main);

const instances = [];
let seed = 1;

const NotificationEx = function (options = {}) {
  const instance = NotificationEx.create(options);
  NotificationEx.position(instance, options.offset);
  NotificationEx.register(instance);

  return instance.vm;
};

NotificationEx.getId = function () {
  return `notification_${seed++}`;
};

NotificationEx.create = function (options) {
  const id = NotificationEx.getId();
  const {
    title,
    message,
    requestId,
    copyButtonName,
    dangerouslyUseHTMLString,
    ...props
  } = options;
  const instance = new NotificationExConstructor({
    data: {
      title,
      message,
      requestId,
      copyButtonName,
      dangerouslyUseHTMLString
    }
  });

  Object.keys(props).forEach((key) => {
    instance.$props[key] = props[key];
  });

  instance.id = id;
  instance.$props.onClose = () => NotificationEx.close(id, options.onClose);
  instance.vm = instance.$mount();
  document.body.appendChild(instance.vm.$el);
  instance.vm.keepAlive = false;
  instance.vm.display = true;
  instance.$el = instance.vm.$el;
  instance.$el.zIndex = PopupManager.nextZIndex();

  return instance;
};

NotificationEx.register = function (instance) {
  instances.push(instance);
};

NotificationEx.position = function (instance, offset = 0) {
  let verticalOffset = offset;

  instances.filter(item => item.position === instance.position).forEach((item) => {
    verticalOffset += item.$el.offsetHeight + 16;
  });
  instance.verticalOffset = verticalOffset + 16;
};

NotificationEx.close = function (id, userOnClose) {
  let index = -1;
  const len = instances.length;
  const instance = instances.filter((inst, i) => {
    if (inst.id === id) {
      index = i;
      return true;
    }
    return false;
  })[0];
  if (!instance) return;

  if (typeof userOnClose === 'function') {
    userOnClose(instance);
  }
  instances.splice(index, 1);

  if (len <= 1) return;
  const { position } = instance;
  const removedHeight = instance.$el.offsetHeight;
  for (let i = index; i < len - 1; i++) {
    if (instances[i].position === position) {
      const vertical = parseInt(instances[i].$el.style[instance.verticalProperty], 10);
      instances[i].$el.style[instance.verticalProperty] = `${vertical - removedHeight - 16}px`;
    }
  }
};

NotificationEx.closeAll = function () {
  for (let i = instances.length - 1; i >= 0; i--) {
    instances[i].close();
  }
};

['success', 'warning', 'error', 'info', 'progress'].forEach((type) => {
  NotificationEx[type] = (options) => {
    if (typeof options === 'string' || isVNode(options)) {
      options = {
        message: options
      };
    }
    options.type = type;
    return NotificationEx(options);
  };
});

export default NotificationEx;
